export const defaultSettings = {
  rootMargin: '0px',
  tracker: true
}